export const Data = [
    {
      id: 1,
      title: 'adidas',
      description: 'Carton Astronault Tshirts',
      image: 'http://res.cloudinary.com/dabfyhdoz/image/upload/v1524685644/crop_t7wwso.png',
      price: 140,
    },
    {
      id: 2,
      title: 'adidas',
      description: 'Carton Astronault Tshirts',
      image: 'http://res.cloudinary.com/dabfyhdoz/image/upload/v1524685644/dress1_mwxgbb.png',
      price: 158,
    },
    {
      id: 3,
      title: 'adidas',
      description: 'Carton Astronault Tshirts',
      image: 'http://res.cloudinary.com/dabfyhdoz/image/upload/v1524685644/dress2_uxttkd.png',
      price: 478,
    },
    {
      id: 4,
      title: 'adidas',
      description: 'Carton Astronault Tshirts',
      image: 'http://res.cloudinary.com/dabfyhdoz/image/upload/v1524685644/jacket_nfcov5.png',
      price: 578,
    },
  ];
  export default Data;